/** Recorta a imagem no centro em quadrado e reduz para `size`×`size`, já em base64 (sem prefixo). */
export async function squareImageBase64(
  file: File,
  size = 256,
): Promise<{ mime_type: 'image/webp' | 'image/jpeg'; data_base64: string }> {
  const bitmap = await createImageBitmap(file).catch(() => {
    throw new Error('Não foi possível ler a imagem. Use PNG, JPG ou WEBP.');
  });
  const side = Math.min(bitmap.width, bitmap.height);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Seu navegador não conseguiu processar a imagem.');
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(
    bitmap,
    (bitmap.width - side) / 2,
    (bitmap.height - side) / 2,
    side,
    side,
    0,
    0,
    size,
    size,
  );
  bitmap.close();
  const toBlob = (type: string) =>
    new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, type, 0.86));
  // WEBP onde houver suporte; senão JPEG (Safari antigo devolve PNG para tipos que não conhece).
  let blob = await toBlob('image/webp');
  if (!blob || blob.type !== 'image/webp') blob = await toBlob('image/jpeg');
  if (!blob) throw new Error('Não foi possível gerar a imagem.');
  const bytes = new Uint8Array(await blob.arrayBuffer());
  let binary = '';
  for (let i = 0; i < bytes.length; i += 0x8000)
    binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return {
    mime_type: blob.type === 'image/webp' ? 'image/webp' : 'image/jpeg',
    data_base64: btoa(binary),
  };
}
